@if (context$ | async; as ctx) {
  <ng-container>
    <flx-resource-header [breadcrumbs]="breadcrumbs"></flx-resource-header>
    <div class="p-8 h-full">
      <flx-card class="h-full rounded-2xl">
        <div class="flex flex-col gap-8 pt-1 h-full">
          <label class="text-xl font-bold">Runtime Exception</label>
          <flx-exception-details-content
            [processException]="ctx.processException"
            [applicationDetails]="ctx.applicationDetails"
            [loading]="ctx.loading"
            class="h-full"
          ></flx-exception-details-content>
        </div>
      </flx-card>
    </div>
  </ng-container>
}
